function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#515262"
    },
    cx: 256,
    cy: 256,
    r: 248
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6464"
    },
    cx: 256,
    cy: 256,
    r: 246
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFF2FA"
    },
    cx: 256,
    cy: 256,
    r: 151
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M96.629,163.987l-55.433-32.004C20.088,168.465,8,210.82,8,256h64 C72,222.479,80.968,191.055,96.629,163.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M163.987,96.629l-32.004-55.434C94.35,62.971,62.971,94.35,41.196,131.983l55.433,32.004 C112.785,136.065,136.065,112.785,163.987,96.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M256,72V8c-45.181,0-87.535,12.087-124.017,33.196l32.004,55.434C191.055,80.969,222.479,72,256,72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M440,256h64c0-45.18-12.087-87.535-33.196-124.017l-55.433,32.004 C431.032,191.055,440,222.479,440,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M415.371,163.987l55.433-32.004c-21.774-37.633-53.153-69.012-90.787-90.787l-32.004,55.433 C375.935,112.785,399.215,136.065,415.371,163.987z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M348.013,96.629l32.004-55.433C343.535,20.088,301.18,8,256,8v64 C289.521,72,320.945,80.969,348.013,96.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M72,256H8c0,45.18,12.088,87.535,33.196,124.018l55.433-32.005C80.968,320.945,72,289.521,72,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M348.013,415.371l32.004,55.433c37.633-21.774,69.012-53.153,90.787-90.786l-55.433-32.005 C399.215,375.935,375.935,399.215,348.013,415.371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M96.629,348.013l-55.433,32.005c21.774,37.633,53.153,69.012,90.787,90.786l32.004-55.433 C136.065,399.215,112.785,375.935,96.629,348.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M440,256c0,33.521-8.968,64.945-24.629,92.013l55.433,32.005C491.913,343.535,504,301.18,504,256 H440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M256,440v64c45.18,0,87.535-12.088,124.017-33.196l-32.004-55.433 C320.945,431.032,289.521,440,256,440z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M163.987,415.371l-32.004,55.433C168.465,491.913,210.82,504,256,504v-64 C222.479,440,191.055,431.032,163.987,415.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M395.703,198.312c-4.977-12.037-11.709-23.604-20.01-34.378l-3.391-4.401l22.786-13.155l2.588,3.444 c8.753,11.649,15.921,23.913,21.305,36.448l1.705,3.97l-22.863,13.2L395.703,198.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M393.788,152.743l-14.244,8.223c8.335,10.819,15.359,22.687,20.652,35.488l14.315-8.265 C409.055,175.483,401.993,163.664,393.788,152.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M348.066,136.308c-10.774-8.301-22.341-15.033-34.378-20.01l-5.128-2.12l13.2-22.863l3.97,1.705 c12.536,5.384,24.798,12.552,36.448,21.305l3.444,2.588l-13.154,22.786L348.066,136.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M315.546,111.804c12.801,5.293,24.669,12.316,35.488,20.652l8.223-14.244 c-10.921-8.205-22.741-15.267-35.446-20.724L315.546,111.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M275.894,106.302c-7.572-0.998-13.893-1.463-19.894-1.463s-12.322,0.465-19.894,1.463l-5.499,0.725 V80.575l4.287-0.512c7.747-0.925,14.651-1.374,21.105-1.374s13.358,0.449,21.105,1.374l4.287,0.512v26.451L275.894,106.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M235.471,84.892v16.589c6.734-0.888,13.553-1.504,20.529-1.504s13.795,0.617,20.529,1.504V84.892 c-6.745-0.805-13.571-1.339-20.529-1.339S242.216,84.087,235.471,84.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M404.974,281.393l0.725-5.499c0.998-7.572,1.462-13.893,1.462-19.894s-0.465-12.322-1.462-19.894 l-0.725-5.499h26.452l0.511,4.287c0.925,7.747,1.374,14.65,1.374,21.105c0,6.457-0.45,13.36-1.375,21.106l-0.512,4.287h-26.45 V281.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M412.024,256c0,6.977-0.617,13.795-1.504,20.53h16.588c0.806-6.746,1.34-13.571,1.34-20.53 c0-6.958-0.534-13.784-1.339-20.529H410.52C411.407,242.205,412.024,249.023,412.024,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M80.576,281.393l-0.512-4.287C79.14,269.36,78.69,262.457,78.69,256 c0-6.455,0.449-13.358,1.374-21.105l0.511-4.287h26.452l-0.725,5.499c-0.998,7.572-1.463,13.893-1.463,19.894 s0.465,12.322,1.463,19.894l0.725,5.499H80.576V281.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M99.976,256c0-6.977,0.617-13.795,1.504-20.529H84.892c-0.805,6.745-1.339,13.571-1.339,20.529 c0,6.959,0.534,13.784,1.34,20.53h16.588C100.593,269.795,99.976,262.977,99.976,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M146.377,116.912l3.444-2.588c11.649-8.752,23.912-15.921,36.448-21.305l3.97-1.705l13.2,22.863 l-5.128,2.12c-12.037,4.977-23.604,11.709-34.378,20.01l-4.402,3.391L146.377,116.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M160.966,132.456c10.819-8.335,22.687-15.359,35.488-20.652l-8.265-14.315 c-12.706,5.457-24.525,12.519-35.446,20.724L160.966,132.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M372.302,352.468l3.391-4.401c8.301-10.774,15.033-22.341,20.01-34.378l2.12-5.128l22.863,13.2 l-1.705,3.97c-5.383,12.533-12.551,24.796-21.305,36.447l-2.588,3.444L372.302,352.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M414.512,323.812l-14.315-8.265c-5.293,12.801-12.316,24.668-20.651,35.488l14.243,8.223 C401.993,348.336,409.056,336.517,414.512,323.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M256,433.311c-6.455,0-13.358-0.449-21.105-1.374l-4.287-0.511v-26.451l5.499,0.725 c7.572,0.998,13.893,1.462,19.894,1.462s12.322-0.465,19.894-1.462l5.499-0.725v26.451l-4.287,0.511 C269.358,432.861,262.455,433.311,256,433.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M276.529,427.108V410.52c-6.734,0.888-13.553,1.505-20.529,1.505s-13.795-0.617-20.529-1.505v16.589 c6.745,0.805,13.571,1.339,20.529,1.339C262.958,428.448,269.784,427.913,276.529,427.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M308.561,397.822l5.128-2.12c12.037-4.977,23.604-11.709,34.378-20.01l4.402-3.391l13.154,22.785 l-3.444,2.588c-11.65,8.753-23.913,15.921-36.448,21.305l-3.97,1.705L308.561,397.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M351.034,379.545c-10.819,8.335-22.687,15.358-35.488,20.651l8.265,14.315 c12.705-5.457,24.525-12.519,35.446-20.725L351.034,379.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M186.27,418.98c-12.535-5.384-24.798-12.552-36.448-21.305l-3.444-2.588l13.154-22.785l4.402,3.391 c10.774,8.301,22.341,15.033,34.378,20.01l5.128,2.12l-13.2,22.863L186.27,418.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M196.454,400.196c-12.801-5.293-24.669-12.316-35.488-20.651l-8.223,14.242 c10.921,8.206,22.741,15.268,35.446,20.725L196.454,400.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M114.324,362.178c-8.754-11.651-15.922-23.914-21.305-36.447l-1.705-3.97l22.863-13.2l2.12,5.128 c4.977,12.037,11.709,23.604,20.01,34.378l3.391,4.401l-22.786,13.154L114.324,362.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M132.455,351.034c-8.335-10.819-15.358-22.687-20.651-35.488l-14.315,8.265 c5.456,12.705,12.519,24.524,20.724,35.445L132.455,351.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M91.315,190.24l1.705-3.97c5.384-12.535,12.552-24.798,21.305-36.448l2.588-3.444l22.786,13.155 l-3.391,4.401c-8.301,10.774-15.033,22.341-20.01,34.378l-2.12,5.128L91.315,190.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M97.488,188.188l14.315,8.265c5.293-12.801,12.316-24.669,20.651-35.488l-14.243-8.223 C110.007,163.664,102.945,175.483,97.488,188.188z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M262.007,151.4c25.81,33.383,65.164,72.744,98.542,98.558c3.967,3.067,3.967,8.996,0,12.064 c-33.378,25.814-72.732,65.174-98.542,98.558c-3.068,3.968-8.998,3.968-12.066,0c-25.81-33.384-65.164-72.744-98.542-98.558 c-3.967-3.068-3.967-8.997,0-12.064c33.378-25.814,72.732-65.175,98.542-98.558C253.009,147.432,258.938,147.432,262.007,151.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B29"
    },
    d: "M437.02,74.98C388.667,26.628,324.38,0,256,0S123.333,26.628,74.98,74.98S0,187.62,0,256 s26.628,132.668,74.98,181.02C123.333,485.372,187.62,512,256,512s132.667-26.628,181.02-74.98C485.372,388.668,512,324.38,512,256 S485.372,123.333,437.02,74.98z M467.689,368.981L426.1,344.97c12.809-24.39,20.521-51.852,21.721-80.97h48.032 C494.606,301.847,484.559,337.501,467.689,368.981z M248,447.821v48.032c-37.847-1.247-73.501-11.293-104.981-28.163l24.012-41.59 C191.42,438.908,218.882,446.621,248,447.821z M264,447.821c29.118-1.2,56.58-8.913,80.97-21.721l24.012,41.59 c-31.48,16.87-67.135,26.917-104.981,28.163L264,447.821L264,447.821z M256,432c-97.047,0-176-78.953-176-176S158.953,80,256,80 s176,78.953,176,176S353.047,432,256,432z M16.147,264h48.032c1.2,29.118,8.913,56.58,21.721,80.97l-41.59,24.012 C27.441,337.501,17.394,301.847,16.147,264z M44.311,143.019L85.9,167.03C73.092,191.42,65.379,218.882,64.179,248H16.147 C17.394,210.153,27.441,174.499,44.311,143.019z M264,64.179V16.147c37.847,1.246,73.501,11.293,104.981,28.163L344.97,85.9 C320.58,73.092,293.118,65.379,264,64.179z M248,64.179c-29.118,1.2-56.58,8.913-80.97,21.721l-24.012-41.59 c31.48-16.87,67.135-26.917,104.981-28.163L248,64.179L248,64.179z M447.821,248c-1.2-29.118-8.913-56.58-21.721-80.97 l41.59-24.012c16.87,31.48,26.917,67.135,28.163,104.981L447.821,248L447.821,248z M459.663,129.178l-41.581,24.007 c-15.168-23.827-35.439-44.099-59.267-59.267l24.007-41.581C413.904,71.762,440.238,98.096,459.663,129.178z M129.178,52.337 l24.007,41.581c-23.827,15.168-44.099,35.439-59.267,59.267l-41.581-24.007C71.762,98.096,98.096,71.762,129.178,52.337z  M52.337,382.822l41.581-24.007c15.168,23.827,35.439,44.099,59.267,59.267l-24.007,41.581 C98.096,440.238,71.762,413.904,52.337,382.822z M382.822,459.663l-24.007-41.581c23.827-15.168,44.099-35.439,59.267-59.267 l41.581,24.007C440.238,413.904,413.904,440.238,382.822,459.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B29"
    },
    d: "M362.101,158.641c1.578,1.719,3.733,2.59,5.895,2.59c1.933,0,3.872-0.697,5.408-2.106 c3.255-2.988,3.471-8.049,0.483-11.304c-3.086-3.361-6.354-6.629-9.714-9.713c-3.254-2.987-8.315-2.771-11.303,0.484 c-2.988,3.255-2.771,8.315,0.484,11.303C356.379,152.671,359.322,155.614,362.101,158.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B29"
    },
    d: "M112,256c0-79.402,64.598-144,144-144c23.799,0,47.377,5.925,68.187,17.134 c3.89,2.095,8.742,0.641,10.837-3.249c2.095-3.891,0.64-8.742-3.25-10.838C308.641,102.586,282.439,96,256,96 c-88.224,0-160,71.776-160,160c0,36.744,12.766,72.633,35.947,101.056c1.582,1.939,3.883,2.944,6.205,2.944 c1.777,0,3.566-0.59,5.051-1.801c3.424-2.792,3.936-7.832,1.144-11.256C123.487,321.368,112,289.07,112,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B29"
    },
    d: "M396.937,180.196c-2.097-3.89-6.948-5.343-10.838-3.247c-3.889,2.096-5.343,6.948-3.247,10.837 C394.07,208.602,400,232.19,400,256c0,79.402-64.598,144-144,144c-33.071,0-65.37-11.488-90.946-32.349 c-3.423-2.792-8.462-2.281-11.256,1.144c-2.792,3.424-2.281,8.463,1.144,11.256C183.365,403.233,219.254,416,256,416 c88.224,0,160-71.776,160-160C416,229.549,409.408,203.336,396.937,180.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2B29"
    },
    d: "M372.706,249.53c-36.384-26.461-83.775-73.852-110.236-110.236c-1.505-2.07-3.91-3.294-6.47-3.294 s-4.964,1.225-6.47,3.294c-26.461,36.384-73.852,83.775-110.236,110.236c-2.07,1.505-3.294,3.91-3.294,6.47s1.225,4.964,3.294,6.47 c36.384,26.461,83.775,73.852,110.236,110.236c1.505,2.07,3.91,3.294,6.47,3.294s4.964-1.225,6.47-3.294 c26.461-36.384,73.852-83.775,110.236-110.236c2.07-1.505,3.294-3.91,3.294-6.47S374.775,251.036,372.706,249.53z M256,354.688 c-26.044-33.604-65.084-72.644-98.688-98.688c33.604-26.044,72.644-65.084,98.688-98.688 c26.044,33.604,65.084,72.644,98.688,98.688C321.084,282.044,282.044,321.084,256,354.688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipBalance);
export default __webpack_public_path__ + "static/media/chip-balance.528ba39e7af6e4ad85b5f27e645e6810.svg";
export { ForwardRef as ReactComponent };